import React, { useState } from 'react';
import axios from 'axios';

const TOPIC_OPTIONS = [
  'General enquiry',
  'Book a demo',
  'Pricing & plans',
  'Partnerships',
  'Support',
];

function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    topic: TOPIC_OPTIONS[0],
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const emailHTML = `
      <h2>New Contact Message</h2>
      <p><strong>Topic:</strong> ${form.topic}</p>
      <p><strong>Company:</strong> ${form.company || '—'}</p>
      <p>${form.message}</p>
      <br/>
      <p>
        User Details:<br/>
        Name: ${form.name}<br/>
        Email: ${form.email}
      </p>
    `;

    try {
      await axios.post(
        'https://nurturer-sendgrid-backend.vercel.app/send-email',
        {
          to: 'nealluslabs@gmail.com',
          subject: `New Message From Contact Page — ${form.topic}`,
          htmlMessage: emailHTML,
          name: form.name,
          userEmail: form.email,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setSubmitted(true);
      setForm({
        name: '',
        email: '',
        company: '',
        topic: TOPIC_OPTIONS[0],
        message: '',
      });
    } catch (error) {
      console.error('CONTACT PAGE ERROR=====>', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card form-card">
      <h2>Send us a message</h2>
      <div className="sub">Tell us a little about you and we&apos;ll be in touch.</div>
      {submitted && (
        <p className="sub" style={{ color: 'var(--primary)', marginBottom: 16 }}>
          Thanks — your message has been sent. We&apos;ll be in touch soon.
        </p>
      )}
      <form onSubmit={handleSubmit}>
        <div className="field row2">
          <div className="field">
            <label htmlFor="name">Full name</label>
            <input
              className="inp"
              id="name"
              type="text"
              placeholder="Jordan Avery"
              required
              value={form.name}
              onChange={handleChange('name')}
            />
          </div>
          <div className="field">
            <label htmlFor="email">Work email</label>
            <input
              className="inp"
              id="email"
              type="email"
              placeholder="you@company.com"
              required
              value={form.email}
              onChange={handleChange('email')}
            />
          </div>
        </div>
        <div className="field row2">
          <div className="field">
            <label htmlFor="company">Company</label>
            <input
              className="inp"
              id="company"
              type="text"
              placeholder="Company name"
              value={form.company}
              onChange={handleChange('company')}
            />
          </div>
          <div className="field">
            <label htmlFor="topic">How can we help?</label>
            <select className="inp" id="topic" value={form.topic} onChange={handleChange('topic')}>
              {TOPIC_OPTIONS.map((option) => (
                <option key={option}>{option}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="field">
          <label htmlFor="message">Message</label>
          <textarea
            className="inp"
            id="message"
            placeholder="What would you like to talk about?"
            value={form.message}
            onChange={handleChange('message')}
          />
        </div>
        <div className="form-foot">
          <button className="btn btn-primary" type="submit" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send message'}
          </button>
          <span className="note">We&apos;ll never share your details.</span>
        </div>
      </form>
    </div>
  );
}

export default ContactForm;
